//index.js

import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import reportWebVitals from './reportWebVitals';
// import './i18n/i18n'; // Import the i18n configuration
import './components/web/i18n/i18n'; // Import the i18n configuration

// Find the root element in your HTML
const container = document.getElementById('root');

// Create a root using the container
const root = createRoot(container);

// Render your app within the root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register Service Worker for performance optimization
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

// For performance measurement, you can pass a function to reportWebVitals
// reportWebVitals(console.log);
// Learn more about reportWebVitals in the included README.md file.
reportWebVitals();
